// FIX SCREEN RESIZED // FULLSCREEN STRETCH
// FIX NOTES PROPORTIONATE TO CIRCLES, DIFFERENT SCALE
//VISUAL HIGHLIGHT ELEMENT

// P5 ELEMENT
// START SCREEN?
// CALL ELEMENT
// REAL-TIME ELEMENT?
// GENERATIVE ELEMENT?
// LEARN SHADERS

import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import * as Tone from 'tone'
import { WebGLUtils } from 'three';
let First;
let start = false;
let meshes = []
let x = -0.2
let soundlist = []
let speed = 0.001
let speed2 = 0.001
let z = 10
let color = new THREE.Color(0.2 + Math.sin(x / 10), 0.2 + Math.sin(x / 8), 0.2 + Math.sin(x / 3));
const canvas = document.querySelector('canvas.webgl')
const pointer = new THREE.Vector2();
let raycaster = new THREE.Raycaster();
let INTERSECTED
let recent;
let recentList = []
let oscs = []
let osc2 = []
let meshez = []
let arp = [220]
let arp2 = [220]
let root = 12
let analyzer = new Tone.FFT(512);
let kickvol
let synthvol
let slip = false;

const kit = new Tone.Players({
   "kick": "Kick1.mp3"
});
kit.connect(analyzer).toDestination();
Tone.Transport.scheduleRepeat(playPulse, 2);

let reverb = new Tone.Reverb(5).toDestination();

const synth = new Tone.MonoSynth({
   oscillator: {
      type: "square"
   },
   envelope: {
      attack: 0.1
   }
}).connect(reverb);

const synth2 = new Tone.MonoSynth({
   oscillator: {
      type: "square"
   },
   envelope: {
      attack: 0.1
   }
}).connect(reverb);


synth.volume.value = -16
kit.volume.value = - 14

var pattern = new Tone.Pattern(function (time, note) {
   synth.triggerAttackRelease(note, 0.6);
}, arp, "upDown");

var pattern2 = new Tone.Pattern(function (time, note) {
   synth2.triggerAttackRelease(note, 0.3);
}, arp2, "upDown");

pattern2.playbackRate = 2

Tone.Transport.bpm.value = 400;


function playPulse(time) {
   kit.player("kick").start(time);
}

let messages = [
   'There is no end to the beginning it is still beginning, and it is still ending.',
   'So hopefully daft, these trenches of last resolve. Bubbles, all bubbles and future fuck. Mud wet future fuck. Then you got it from the email.',
   'Spider fillament, streched around our eyes, stretched across my bursting body like a skimpy bikini.',
   'The floor flooded and little pitter.',
   'Slender little notions on the day the stock dropped, someone left a cigerette in the trashcan. I stomped it out when no on when was looking.',
   'Im the one who fired Gill He was getting so sloppy with his reports.',
   'Do you remember when Terry brought her cat into the office, simon nearly had a fit. Fits of fire, his black stubble chubby chortle pointer finger blundered out and...',
   'Theoretical answer number 17, it was bar trivia, you let it go to try and kiss frank.',
   'Then it all fell, on wednesdays no more casual tank tops.',
   'I just wanted to hear what was going on the cibicle next to me, I wasnt trying to spy. It came off like that and you painted me as a creep',
   'Theodores dream, was an ant that climbed the whole tower, they were in the dream for 3 hours, dreamtime: 4.7 years of climbing. They finally reached the top',
   'heldgjsldkjglsdgkj sdgsdlgkjlsdkgj gdslkjgslo',
   'helsdlgksjdlgkjsd sdglkjsdlgkjslo',
   'helsdgsdlgkjlsdkgj dsglkjgsdlo',
   'hellsdlgkjlsdkgjo',
   'hellsdlgkjsldkgjlsdkgjo',
   'hellsldgkjsdlkgjsldkgjo',
   'helsdlgkjsdlgkjlsdkgjlo',
   'hellsdgsdgsdg sdg sdgsgd sdgsdgo',
   'hello how are you doing today this is the new sizhanian archives, ready for you, ready for us all.'
]


let blood = 'MK-Ultra was a top-secret CIA project in which the agency . conducted hundreds of clandestine experiments—sometimes on unwitting U.S. citizens—to assess the potential use of LSD and other drugs for mind .  control, information gathering and psychological torture. Though Project MK-Ultra lasted from 1953 until about 1973, details of the illicit program didn’t become public until 1975, during a congressional investigation into widespread illegal CIA . activities within the United States and around the world.The Cold War and Project MK-UltraIn the 1950s and 1960s—the height of the Cold War—the United States government feared that Soviet, Chinese and North Korean agents were using mind . control to brainwash U.S. prisoners of war in Korea.In response, Allan Dulles, director of the Central Intelligence Agency (CIA), approved Project MK-Ultra in 1953. The covert operation aimed to develop techniques that could be used against Soviet bloc enemies to control human behavior with drugs and other  . psychological manipulators.  The program involved more than 150 human experiments involving psychedelic drugs, paralytics and electroshock therapy. Sometimes the test subjects knew they were . participating in a study—but at other times, they had no idea, even when the hallucinogens started taking effect.'
let drop = blood.split(' ')
let i = 0

function map(value, a, b, c, d) {
   value = (value - a) / (b - a);
   return c + value * (d - c);
}

// Scene
const scene = new THREE.Scene()

function onPointerMove(event) {

   pointer.x = (event.clientX / window.innerWidth) * 2 - 1;
   pointer.y = - (event.clientY / window.innerHeight) * 2 + 1;

}

const sizes = {
   width: window.innerWidth,
   height: window.innerHeight
}

/**
 * Renderer
 */
var renderer = new THREE.WebGLRenderer({
   canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

var light4 = new THREE.AmbientLight(0x404040); // soft white light
light4.intensity = 3
scene.add(light4);

window.addEventListener('click', () => {
   Tone.start()
})
// Base camera
const camera = new THREE.OrthographicCamera(sizes.width / - 48, sizes.width / 48, sizes.height / 48, sizes.height / - 48, 0.1, 1000)

//RESIZER
window.addEventListener('resize', () => {
   // Update sizes
   sizes.width = window.innerWidth
   sizes.height = window.innerHeight

   // Update camera
   camera.aspect = (sizes.width / sizes.height)
   camera.updateProjectionMatrix();

   camera.width = sizes * camera.aspect / -2;
   camera.height = sizes * camera.aspect / 2;

   // Update renderer
   renderer.setSize(sizes.width, sizes.height)
   renderer.setPixelRatio(Math.min(2, 2))
})

scene.add(camera)
scene.background = new THREE.Color(0.2, 0.4, 1);

var sloop1 = new THREE.Color(255, 0, 0)
var sloop2 = new THREE.Color(0, 255, 0)

const material = new THREE.MeshToonMaterial(
   {
      color: sloop2,
      emissive: sloop1,
      emissiveIntensity: 1000,
      lightMapIntensity: 1000
   }
)

// SHAPES
/////////////////
////////////////
const mesh7 = new THREE.Mesh(new THREE.BoxGeometry(250, 250, 250), new THREE.MeshPhongMaterial(
   {
      color: color,
      depthWrite: false,
      wireframe: true,
      wireframeLinewidth: 1
   }));

mesh7.receiveShadow = true;
scene.add(mesh7);

let listener4 = new THREE.AudioListener({ gain: -102 });
camera.add(listener4);

const geometry3 = new THREE.BoxGeometry(200, 200, 1)
const mesh3 = new THREE.Mesh(geometry3, material)
scene.add(mesh3)
mesh3.position.x = 0
mesh3.position.y = 0
mesh3.position.z = 2
mesh3.parent = camera

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true
controls.zoomSpeed = 0.65
controls.target.set(0, 0, 0.1);
controls.minZoom = 0.04
controls.maxZoom = 1.2
controls.screenSpacePanning = false
/////

renderer.setAnimationLoop(function () {
   renderer.render(scene, camera);
   Tone.start()
});
controls.update();


for (let i = 0; i < 200; i = i + 15) {

   let sphere = new THREE.SphereGeometry(i / 7, 64, 128)
   let toon = new THREE.MeshToonMaterial()

   const mesh2 = new THREE.Mesh(sphere, toon)
   mesh2.position.x = Math.random() * 200;
   mesh2.position.y = Math.random() * 200;
   mesh2.position.z = Math.random() * 200;

   var sounds = new THREE.PositionalAudio(listener4);
   soundlist.push(sounds)
   Tone.setContext(sounds.context);

   let oscillators = new Tone.Oscillator(Math.abs(i * root), "triangle").toDestination();

   oscs.push(oscillators)
   sounds.setMaxDistance(400)
   sounds.setRefDistance(1000)
   sounds.setNodeSource(oscillators);
   sounds.setRolloffFactor(0.01)
   sounds.setDistanceModel('linear')
   sounds.setDirectionalCone(180, 230, 0.9);
   mesh2.add(sounds);
   scene.add(mesh2)
   meshes.push(mesh2)
   oscillators.volume.value = -36

   const mesh4 = new THREE.Mesh(
      new THREE.SphereGeometry(i / 60, 64, 128),
      new THREE.MeshToonMaterial()
   )
   var sound2 = new THREE.PositionalAudio(listener4);
   Tone.setContext(sound2.context);
   let oscillator2 = new Tone.Oscillator(Math.abs(i * root/2), "square").toDestination();
   osc2.push(oscillator2)
   oscillator2.volume.value = -60
   sound2.setNodeSource(oscillator2);
   sound2.setMaxDistance(800)
   sound2.setRefDistance(1000)
   sound2.setRolloffFactor(0.001)
   sound2.setDistanceModel('linear')
   sound2.setDirectionalCone(180, 230, 0.9);
   scene.add(mesh4)
   mesh4.parent = mesh2
   meshez.push(mesh4)
   mesh4.add(sound2)
}

document.addEventListener('pointermove', onPointerMove);

function checkPass() {
   let password = document.querySelector('input').value
   if (password == 'DORMANT') {
      document.getElementById('starter').remove()
      sizes.width = window.innerWidth
      sizes.height = window.innerHeight

      // Update camera
      camera.aspect = (sizes.width / sizes.height)
      camera.updateProjectionMatrix();

      camera.width = sizes * camera.aspect / -2;
      camera.height = sizes * camera.aspect / 2;

      // Update renderer
      renderer.setSize(sizes.width, sizes.height)
      renderer.setPixelRatio(Math.min(2, 2))

      for (let i = 0; i < oscs.length; i++) {
         oscs[i].start()
      }

      for (let t = 0; t < osc2.length; t++) {
         osc2[t].start()
      }
      
      pattern.start()
      pattern2.start()
      Tone.Transport.start();
      start = true
   }
}

camera.rotation.x = -4.75
camera.rotation.z = -4.75
camera.rotation.y = -7.8
camera.zoom = 0.1

const tick = () => {
   
   let bpmcam = map(camera.zoom, 0.04, 1.2, 220, 107)
   Tone.Transport.bpm.value = bpmcam;
   let frequencyData = analyzer.getValue();
   var scale2 = Math.floor(Math.abs(frequencyData[frequencyData.length - 1])) - 112
   // console.log(scale2)
   controls.target.set(0, 0, 0.1);
   const timer = 0.0001 * Date.now();
   x += speed
   z += speed2


   if (start == false) {
      checkPass()
   }

   // console.log(pointer)

   if(pointer.x > 0.3 && pointer.x < 0.97 && pointer.y < 0.3 && pointer.y > -0.90){
      slip = true
      for (let y = 0; y < meshes.length; y++) {
         oscs[y].volume.rampTo(-200, 5)
         osc2[y].frequency.rampTo("A3", 10)
         osc2[y].volume.rampTo(-50, 5)
         kit.volume.rampTo(-200, 3)    
         synth.volume.rampTo(-200, 5)
         synth2.volume.rampTo(-200, 3) 
         scene.background = new THREE.Color(50, 0, 0)
      
      }
   } else {
         slip = false
      }
   

   raycaster.setFromCamera(pointer, camera);
   const intersects = raycaster.intersectObjects(scene.children, false)

   if (intersects.length > 0) {
      document.getElementById('column').append(drop[i].toUpperCase() + ' ')
 
      if (intersects[0].object != mesh7) {
         INTERSECTED = intersects[0].object;
         recent = INTERSECTED.children[0].source
         recent.volume.rampTo(-18, 1)
         
   
         if (recent != recentList[recentList.length -1]) {
            arp.push(recent.frequency.value / 2)
            arp2.push(recent.frequency.value / 4)
         }
         if (arp.length > 4) {
            arp.shift()
         }

         if (arp2.length > 8) {
            arp2.shift()
         }
         recentList.push(recent)
         for (let y = 0; y < meshes.length; y++) {
            let objects = meshes[y]
            if (objects == INTERSECTED) {
               document.getElementById('overlay').innerHTML = ''
               document.getElementById('overlay').append(messages[y].toUpperCase())
               
            }
         }
      }
   i++
   if(i > drop.length - 5){
      i = 0
   }
   } else {

      root = 12
      document.getElementById('column').innerHTML = ''
      for (let y = 0; y < meshes.length; y++) {
         let objects = meshes[y]
         let object2 = meshez[y]
         object2.position.x = objects.position.x + 5
         objects.updateMatrixWorld()
         object2.updateMatrixWorld()
         let distance = camera.position.distanceTo(objects.position);
         let distance2 = camera.position.distanceTo(object2.position);
         let xplace = objects.position.x + objects.position.z + objects.position.y
         let freqVol = Math.floor(map(xplace, -500, 500, 220, 880))
         let disVol = map(distance, 10, 300, 1, 8)
         let disVol2 = map(distance2, 10, 300, 1, 8)
         let expVol = Math.exp(disVol)
         let expVol2 = Math.exp(disVol2)
         let holderP = -expVol * camera.zoom * 2.3 - 50
         if(slip == false){
         oscs[y].volume.rampTo(holderP, 0.2)
         osc2[y].volume.rampTo(-expVol2 * (camera.zoom * 2.3) - 50, 0.6)
         osc2[y].frequency.rampTo(freqVol)
         kickvol = map(camera.zoom, 0.04, 1.2, -12, -24)
         synthvol = map(camera.zoom, 0.04, 1.2, -30, -16)
         kit.volume.value = kickvol
         synth.volume.value = synthvol
         synth2.volume.value = synthvol -5
         }
         // //////SIDECHAIN
      }


   }
   for (let y = 0; y < meshes.length; y++) {
      let objects = meshes[y]
      let sloop3 = new THREE.Color(255, 0, 0.2 + Math.sin(x / 16));  // white
      objects.material.emissive = sloop3
      objects.material.fog = sloop3
      objects.material.aoMapIntensity = y /10
      objects.material.emissiveIntensity = y /10
      if(slip == false){
      objects.position.x = 100 * Math.cos(timer + y);
      objects.position.y = 100 * Math.sin(timer + y * 1.1);
      objects.position.z = 100 * Math.sin(timer + y * 0.7);
      objects.rotation.y = 10 * Math.sin(timer + y * 0.7);
      objects.rotation.x = 10 * Math.sin(timer + y * 0.7);
      objects.rotation.z = 10 * Math.sin(timer + y * 0.7);
      }
      soundlist[y].setDirectionalCone(40 * Math.cos(timer + y), 40 * Math.sin(timer + y * 1.1), 0.9)

   }
   if (x > 16.5 || x < -1.2) {
      speed = speed * -1
   }

   if (z > 30 || x < 10) {
      speed2 = speed2 * -1
   }

   // console.log(scene.background)

   sloop2 = new THREE.Color(0.2 + Math.sin(x / 40), 0.2 + Math.sin(x / 24), 0.2 + Math.sin(x / 16));  // white
   sloop1 = new THREE.Color(0.2 + Math.sin(x / 20), 0.2 + Math.sin(x / 12), 0.2 + Math.sin(x / 8));  // white
   var light1 = new THREE.Color(0.2 + Math.sin(x / 2), 0, 0.2 + Math.sin(x));
   color = new THREE.Color(0.15 + Math.sin(x / 10), 0.2 + Math.sin(x / 8), 0.2 + Math.sin(x / 30));
   light4 = new THREE.Color(0.2 + Math.sin(x / 5), 0.2 + Math.sin(x / 5), 0.2 + Math.sin(x / 2));
   const near = 10 / camera.zoom
   const far = 15 * camera.zoom
   scene.fog = new THREE.Fog(light1, near, far);
   if(slip == false){
   scene.background = new THREE.Color(0.2 + Math.sin(x + (camera.rotation.x * 2)), 0.2 + Math.sin(x + (camera.rotation.y * 2)), 0.2 + Math.sin(x + (camera.rotation.z * 2)));
   }
   controls.update()
   camera.updateMatrixWorld();
   scene.updateMatrixWorld();

   window.requestAnimationFrame(tick)


}

tick()
